import React from 'react';
import { PropTypes } from 'prop-types';
// style
import styled, { css } from 'styled-components';
import { media, zIndexses } from 'utils/style';
// components
import LogoButton from 'refactored/ui/nav/logoButton';
import { IS_TENANT, isTenantByName } from 'tenant/utils';

const MainMenuMulticolorLogo = ({ className, handleBack, showMulticolor }) => (
  <div className={className}>
    <div className="logoContainer">
      <LogoButton handleBack={handleBack} tabIndex="-1"></LogoButton>
    </div>
    <div className="logoContainer">
      <LogoButton handleBack={handleBack} tabIndex="-1"></LogoButton>
    </div>
    {!IS_TENANT && !isTenantByName('xpo') && (
      <>
        <div className="logoContainer">
          <div className="trapBlock"></div>
        </div>
      </>
    )}
    <div className="logoContainer">
      <LogoButton handleBack={handleBack}></LogoButton>
    </div>
  </div>
);

MainMenuMulticolorLogo.propTypes = {
  handleBack: PropTypes.func,
  showMulticolor: PropTypes.bool,
  className: PropTypes.string,
};

const singleColorCSS = css`
  .logoContainer:last-child {
    width: 100%;
  }
`;
const multiColorCSS = css`
  .logoContainer:last-child {
    width: 75px;
  }
  .logoContainer {
    .multicolor-xpo {
      fill: var(--primary500);
    }
  }
`;

const regularCSS = css`
  .logoContainer {
    position: absolute;
    left: 4px;
    top: 24px;
    ${LogoButton} {
      opacity: 1;
      pointer-events: all;
    }
    transition: width 0.3s ease;
  }
  .trapBlock {
    width: 10px;
    height: 10px;
    background-color: var(--primary500);
    position: absolute;
    top: 20px;
    left: 65px;
    z-index: ${zIndexses.mainMenuMultiColorLogoTrapBlock};
  }
  .logoContainer:last-child {
    overflow: hidden;
    svg {
      fill: white;
    }
  }

  ${singleColorCSS}
`;

const tabletCSS = css`
  ${(props) =>
    props.showMulticolor &&
    css`
      ${multiColorCSS}
    `}
`;

export default styled(MainMenuMulticolorLogo)`
  ${regularCSS};
  ${media.lessThan('huge')`${tabletCSS}`};
`;
